export const RESERVED_SEGMENTS = [
  'admin',
  'academy',
  'student',
  'login',
  'signup',
  'sign_up',
  'find_id',
  'report',
  'learning',
  'homework',
  'vocabulary',
  'exam',
  'mypage',
  'playground'
] as const;

const RESERVED_SET = new Set<string>(RESERVED_SEGMENTS as readonly string[]);

export function isReservedSegment(segment: string): boolean {
  if (!segment) return false;
  return RESERVED_SET.has(segment.toLowerCase());
}

export function sanitizeSlug(input: string): string {
  if (!input) return '';
  let s = input.trim();
  if (!s) return '';

  const takeFirstSegment = (value: string) => {
    const parts = value.split('/').filter(Boolean);
    return parts.length ? parts[0] : '';
  };

  const takeLastSegment = (value: string) => {
    const parts = value.split('/').filter(Boolean);
    return parts.length ? parts[parts.length - 1] : '';
  };

  const takeFirstLabel = (value: string) => {
    const label = value.split('.').filter(Boolean)[0] || value;
    return label;
  };

  s = s.replace(/\\/g, '/');

  if (s.includes('://')) {
    try {
      const u = new URL(s);
      const pathSegment = takeFirstSegment(u.pathname || '');
      if (pathSegment) {
        s = pathSegment;
      } else if (u.hostname) {
        s = takeFirstLabel(u.hostname);
      } else {
        s = '';
      }
    } catch {
      s = takeLastSegment(s);
    }
  } else if (s.includes('.') && s.includes('/')) {
    s = takeLastSegment(s);
  } else if (s.startsWith('/')) {
    s = takeFirstSegment(s);
  } else if (s.includes('/')) {
    s = takeFirstSegment(s);
  } else if (s.includes('.')) {
    s = takeFirstLabel(s);
  }

  s = s.replace(/[^a-zA-Z0-9-_]/g, '');
  return s;
}

export function getSlugPrefix(currentPathname?: string): string {
  try {
    const pathname =
      typeof currentPathname === 'string' && currentPathname.length > 0
        ? currentPathname
        : (typeof window !== 'undefined' ? (window.location?.pathname || '') : '');
    const segments = pathname.split('/').filter(Boolean);
    const first = segments[0] || '';
    const pathSlug = (!isReservedSegment(first) ? sanitizeSlug(first) : '');
    return pathSlug ? `/${pathSlug}` : '';
  } catch {
    return '';
  }
}

export function getPathSlug(currentPathname?: string): string {
  try {
    const pathname =
      typeof currentPathname === 'string' && currentPathname.length > 0
        ? currentPathname
        : (typeof window !== 'undefined' ? (window.location?.pathname || '') : '');
    const segments = pathname.split('/').filter(Boolean);
    const first = segments[0] || '';
    return (!isReservedSegment(first) ? sanitizeSlug(first) : '');
  } catch {
    return '';
  }
}

